<template>
	<AnemicButton @click="$emit('tab-clicked', tab)" :class="{ selected: isSelected }" class="px-5 tab-button mr-1" tile>
		{{ tab }}
	</AnemicButton>
</template>
<script>
export default {
	name: 'InspirationCenterTab',
	props: { tab: { type: String }, isSelected: { type: Boolean } },
};
</script>
<style lang="scss" scoped>
.tab-button {
	height: 30px !important;
	font-size: 14px !important;
	transition: 0.3s !important;
	color: #98a2b7 !important;
	border-radius: 7px !important;
	letter-spacing: 0px !important;
	font-weight: normal !important;
	background: var(--white) !important;
	border: 1px solid var(--tertiary-border-color) !important;
	&.selected {
		color: var(--white) !important;
		background: #7168ca !important;
	}
}
</style>
